<template>
  <el-dialog
    :visible="isShowCement"
    :close-on-click-modal="false"
    :title="$t('notice.公告')"
    class="dialog-dark dialog-include-table"
    width="454px"
    @open="onOpen"
    @close="onClose"
  >
    <el-table
      :data="list"
      :height="230"
      class="table-dark table-noborder"
      tooltip-effect="dark"
    >
      <el-table-column
        :label="$t('notice.内容公告')"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column :label="$t('notice.状态')" prop="name" width="110">
        <template slot-scope="scope">
          <span :class="{ isPublish: scope.row.state !== 1 }">{{
            scope.row.state === 1 ? $t("notice.未发布") : $t("notice.已发布")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('notice.操作')" width="100">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.state === 1"
            :underline="false"
            class="link-mini publish_color"
            @click="publish(scope.row)"
            >{{ $t("notice.发布") }}</el-link
          >
          <el-link
            v-else
            :underline="false"
            class="link-mini"
            type="danger"
            @click="unpublish(scope.row)"
            >{{ $t("notice.取消发布") }}</el-link
          >
        </template>
      </el-table-column>
      <template slot="empty">
        <Blank
          :src="gonggaoImg"
          :text="$t('notice.暂无公告')"
          :width="100"
          :height="94"
        />
      </template>
    </el-table>
    <div slot="footer" class="cement-footer">
      <div class="flex-box flex-v-center flex-1">
        <div class="fontColor">{{ $t("notice.发布方式") }}</div>
        <el-radio-group
          v-model="mode"
          class="radio-button-mini"
          size="mini"
          @change="modeChange"
        >
          <el-radio-button :label="0">{{ $t("notice.单条") }}</el-radio-button>
          <el-radio-button :label="1">{{ $t("notice.多条") }}</el-radio-button>
        </el-radio-group>
        <el-tooltip effect="dark" placement="top" :content="$t('notice.tip')">
          <img class="tip-icon" :src="require('@/svg/tip.svg')" />
        </el-tooltip>
      </div>
      <div>
        <el-button
          class="button-mini"
          type="primary"
          size="mini"
          @click="cementVisible = true"
          >{{ $t("notice.新增公告") }}</el-button
        >
      </div>
    </div>
    <Cement :visible.sync="cementVisible" @action="noticeAdd" />
  </el-dialog>
</template>
<script>
import {
  Dialog,
  Table,
  TableColumn,
  Link,
  RadioGroup,
  RadioButton,
  Tooltip,
} from "element-ui";
import Cement from "./cement.vue";
import { mapGetters } from "vuex";
import {
  getNoticeList,
  noticePublish,
  noticeCancel,
  noticeAdd,
  noticeMode,
} from "@/api/liveRequest/notice";
import { getParameter } from "@/utils/global";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import Blank from "@/components/blank";
import gonggaoImg from "@/assets/images/blank/gonggao.png";
export default {
  name: "Notice",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Link.name]: Link,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Tooltip.name]: Tooltip,
    Cement,
    Blank,
  },
  data() {
    return {
      gonggaoImg,
      // 直播id
      liveId: getParameter("liveId"),
      // 添加公告
      cementVisible: false,
      // 公告列表
      list: [],
      // 公告模式 0单条 1多条
      mode: 0,
    };
  },
  computed: {
    ...mapGetters(["isShowCement", "liveRoomStatus"]),
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
      }
    });
  },
  methods: {
    message_7107(body) {
      if (body.event === "notice/state") {
        this.getNoticeList();
      }
    },
    // 弹窗打开事件
    onOpen() {
      this.getNoticeList();
    },
    // 弹窗关闭事件
    onClose() {
      this.$store.commit("SET_SHOW_CEMENT", false);
    },
    // 获取公告列表
    async getNoticeList() {
      const { code, data } = await getNoticeList(this.liveId);
      if (code === 200) {
        this.list = data.notices;
        this.mode = data.mode;
      }
    },
    // 添加公告
    async noticeAdd({ type, content }) {
      await noticeAdd({
        webcastId: this.liveId,
        state: type,
        title: content,
      });
      this.getNoticeList();
      this.cementVisible = false;
    },
    // 发布
    async publish(item) {
      if (this.liveRoomStatus != 2) {
        return this.$message.warning(this.$t("common.请先开启直播"));
      }
      const { code, msg } = await noticePublish({
        webcastId: this.liveId,
        noticeId: item.id,
      });
      if (code !== 200) {
        this.$message.error(msg);
      }
    },
    // 取消发布
    async unpublish(item) {
      const { code, msg } = await noticeCancel({
        webcastId: this.liveId,
        noticeId: item.id,
      });
      if (code !== 200) {
        this.$message.error(msg);
      }
    },
    // 修改公告模式
    async modeChange() {
      const { code, msg } = await noticeMode({
        webcastId: this.liveId,
        mode: this.mode,
      });
      if (code !== 200) {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cement-footer {
  display: flex;
  align-items: center;
  padding: 0 12px;
}
.dialog-include-table ::v-deep .el-dialog__body {
  padding-bottom: 10px;
}
.publish_color {
  color: #3986ee;
}
.isPublish{
  color: #8A8F99;
}
</style>